import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(n, c) {
  return o(), e("svg", t, c[0] || (c[0] = [
    l("path", {
      fill: "currentColor",
      d: "M1.81 10.714c-.046 0-.058-.023-.034-.058l.245-.316c.023-.035.082-.058.128-.058h4.17c.047 0 .059.035.035.07l-.198.304c-.024.035-.082.07-.117.07zM.048 11.789c-.047 0-.059-.024-.035-.059l.245-.315c.023-.035.082-.059.128-.059h5.327c.047 0 .07.036.058.07l-.093.28c-.012.048-.058.07-.105.07zm2.826 1.074c-.046 0-.058-.035-.035-.07l.164-.292c.023-.035.07-.07.117-.07h2.336c.047 0 .07.035.07.082l-.023.28c0 .047-.047.082-.082.082l-2.546-.012Zm12.125-2.36-1.962.515c-.175.046-.187.058-.339-.117a1.6 1.6 0 0 0-.549-.444 2.03 2.03 0 0 0-2.114.175 2.49 2.49 0 0 0-1.192 2.22c.012.934.655 1.705 1.577 1.833.795.106 1.46-.175 1.986-.77l.316-.433h-2.255c-.245 0-.304-.151-.222-.35.152-.362.432-.97.596-1.273a.32.32 0 0 1 .292-.187h4.252c-.024.315-.024.63-.07.946a5 5 0 0 1-.958 2.29 4.87 4.87 0 0 1-3.33 1.985 4.14 4.14 0 0 1-3.141-.77A3.67 3.67 0 0 1 6.4 13.528a4.58 4.58 0 0 1 .993-3.422 5.2 5.2 0 0 1 3.27-2.021c1.099-.199 2.15-.07 3.096.572.62.409 1.063.97 1.355 1.647.07.105.024.164-.117.199Z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M18.865 16.963a4.38 4.38 0 0 1-2.85-1.028 3.67 3.67 0 0 1-1.262-2.254 4.46 4.46 0 0 1 .946-3.528 4.9 4.9 0 0 1 3.27-1.95 4.32 4.32 0 0 1 3.33.595 3.63 3.63 0 0 1 1.647 2.605 4.51 4.51 0 0 1-1.343 3.96 5.35 5.35 0 0 1-2.804 1.495c-.315.058-.63.07-.934.105m2.78-4.719c-.012-.152-.012-.268-.035-.385a1.93 1.93 0 0 0-2.383-1.554c-1.087.245-1.787.935-2.044 2.033-.21.91.233 1.834 1.074 2.207.643.28 1.285.246 1.904-.07a2.56 2.56 0 0 0 1.484-2.23Z"
    }, null, -1)
  ]));
}
const h = { render: r };
export {
  h as default,
  r as render
};
